import { isStyledValidProp } from "../is-styled-valid-prop/is-styled-valid-prop.es.js";
const styledOptions = {
  shouldForwardProp: isStyledValidProp
};
export {
  styledOptions
};
//# sourceMappingURL=styled-options.es.js.map
